export default function initDisclaimer() {
  Alpine.data('disclaimer', () => ({
    show: false,
    hidden: true,

    init() {
      if (!document.cookie.split('; ').some(cookie => cookie === 'acceptedDisclaimer=true')) {
        this.show = true;
        this.hidden = false;
        document.body.classList.toggle('overflow-hidden');
        this.$nextTick(() => this.$refs.agree.focus());
      }

      document.addEventListener('keydown', (e) => changeFocusState(e, this.$refs.agree, this.$refs.back))
    },

    agree() {
      this.show = false;
      this.hidden = true;
      document.body.classList.toggle('overflow-hidden');
      document.cookie = 'acceptedDisclaimer=true;path=/;samesite=strict;secure';
    }
  }))
}

const changeFocusState = (e: KeyboardEvent, acceptButton: HTMLElement|null, backButton: HTMLElement|null) => {
  if (e.key === 'Tab' && e.target === backButton) {
    e.preventDefault();
    acceptButton && acceptButton.focus();
  } else if (e.key === 'Tab' && e.shiftKey && e.target === backButton) {
    e.preventDefault();
    acceptButton && acceptButton.focus();
  } else if (e.key === 'Tab' && e.shiftKey && e.target === acceptButton) {
    e.preventDefault();
    backButton && backButton.focus();
  }
}